import _ from "underscore";
import { defineStore } from "pinia";
import ProgramDomain from "./model/ProgramDomain";
import ProgramEndpoints from "src/shared/api/program/ProgramEndpoints";
import { reactive } from "vue";
export const useProgramDomainStore = defineStore("programDomainStore", () => {
    const state = reactive({
        programDomains: [],
    });
    const setProgramDomains = (programResponses) => {
        const programDomains = _.map(programResponses, (response) => new ProgramDomain(response));
        state.programDomains = programDomains;
    };
    const fetchProgramDomains = () => {
        return new Promise((resolve, reject) => {
            ProgramEndpoints.getPrograms()
                .done((programResponses) => {
                setProgramDomains(programResponses);
                resolve();
            })
                .fail(() => reject());
        });
    };
    const listProgramDomains = () => {
        return state.programDomains;
    };
    return {
        fetchProgramDomains,
        listProgramDomains,
    };
});
